import { useCommonStore } from '~/states/commonStore'

import defaultTheme from '~/styles/theme'
import { darkTheme, lightTheme } from '~/styles/mode'

const useTheme = () => {
  const { isLightMode } = useCommonStore()

  const theme = { ...defaultTheme, colors: isLightMode ? lightTheme : darkTheme }

  return { theme }
}

export default useTheme
